<template>
  <div class="mt-4 flex">
    <div
      v-for="(step, key, index) in steps"
      :key="key"
      class="flex cursor-pointer items-center"
      :class="index === 0 ? 'order-1' : 'order-3'"
      @click="changeStep(index)">
      <div
        class="mr-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-lg"
        :class="index === current ? 'bg-gradient-black-01 text-white' : 'bg-gray-200 text-gray-400'">
        {{ index + 1 }}
      </div>
      <span
        class="text-sm lg:text-base"
        :class="index === current ? 'text-gray-600' : 'hidden text-gray-300 lg:block'"
        >{{ step }}</span
      >
    </div>
    <div class="pointer-events-none order-2 mx-4 flex items-center lg:mx-8">
      <div class="h-[5px] w-[5px] rounded-full bg-gray-200" />
      <div class="h-px w-14 bg-gray-200 lg:w-24" />
      <div class="h-[5px] w-[5px] rounded-full bg-gray-200" />
    </div>
  </div>
</template>

<script setup lang="ts">
  type stepsProps = {
    steps: {
      step1: string
      step2: string
    }
    current: number
  }
  defineProps<stepsProps>()

  const emit = defineEmits(['changeStep'])

  const changeStep = (step: number) => {
    emit('changeStep', step)
  }
</script>
